export default __webpack_public_path__ + "static/infinity-rewards-desktop-fced5677631a5af232fcd46f050fc9e2.png";